
import { defineComponent, onUpdated, PropType, reactive, ref, watch } from 'vue'
import Memo from '../types/Memo'
import SaveButton from './SaveButton.vue'
import DeleteButton from './DeleteButton.vue'

interface State {
  editingMemo: Memo | undefined;
}

export default defineComponent({
  name: 'MemoForm',
  components: {
    SaveButton,
    DeleteButton,
  },
  props: {
    editingMemo: {
      type: Object as PropType<Memo>
    }
  },
  directives: {
    focus: {
    // ディレクティブの定義
      mounted(el) {
        el.focus()
      },
    }
  },
  emits: ['save', 'deleteValue'],
  setup(props, context) {
    const titleForm = ref<HTMLInputElement>();
    const state = reactive<State>({
      editingMemo: props.editingMemo
    })

    watch(() => props.editingMemo, () =>  {
      titleForm.value?.focus()
    })

    onUpdated(() => {
      state.editingMemo = props.editingMemo
    })

    const saveMemo = () => {
      context.emit('save', state.editingMemo)
    }

    const deleteMemo = () => {
      context.emit('deleteValue', state.editingMemo)
    }

    return {
      state,
      saveMemo,
      deleteMemo,
      titleForm
    }
  },
})
